import SportIcon from '../SportIcon/SportIcon';
import styles from '../WelcomeMessage/WelcomeMessage.module.css';

const NowViewingBanner = ({ athlete }) => {
  if (!athlete) return null;

  const fullName = `${athlete.firstName} ${athlete.lastName}`;
  const sport = athlete.sports?.[0];

  return (
    <div className={styles.wrapper}>
      <h2 className={styles.greeting}>
        Now Viewing:{' '}
        <span className={styles.nameWithIcon}>
          <strong>{fullName}</strong>
          {sport && (
            <span className={styles.icon}>
              <SportIcon sport={sport} size={22} />
            </span>
          )}
        </span>
      </h2>
    </div>
  );
};

export default NowViewingBanner;